import { render, staticRenderFns } from "./PopupShare.vue?vue&type=template&id=a58c6b48"
import script from "./PopupShare.vue?vue&type=script&lang=js"
export * from "./PopupShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports